<div class="container-fluid row">
  <div #graphContainer class="col-md-11">
    <svg #graph></svg>
  </div>
  <div class="col-md-1" style="margin-top: 3%">
    <a class="control-menu" [matMenuTriggerFor]="typeMenu"><i class="zmdi zmdi-hc-2x zmdi-more-vert"></i></a>
  </div>
  <mat-menu #typeMenu="matMenu">
    <mat-slide-toggle style="padding: 10px 5px" [checked]="showBlockLabels" (change)="toggleBlockLabels()" (click)="$event.stopPropagation()">
      <span>Block labels</span>
    </mat-slide-toggle>
    <mat-divider></mat-divider>
    <mat-slide-toggle style="padding: 10px 5px" [checked]="showGridLines" (change)="toggleGridLines()"
      (click)="$event.stopPropagation()">
      <span>Grid lines</span>
    </mat-slide-toggle>
    <mat-divider></mat-divider>
    <mat-slide-toggle style="padding: 10px 5px" [checked]="showStd" (change)="turnOnOffStd()" (click)="$event.stopPropagation()">
      <span style="text-overflow:clip;">STD</span>
    </mat-slide-toggle>
    @for (plotType of plotTypes; track plotType) {
      <button mat-menu-item (click)="changeType(plotType, $event)">
        <span>{{plotType.name}}</span>
        @if (selectedTypes.includes(plotType.index)) {
          <i class="zmdi zmdi-check" style="margin-left:2px;"></i>
        }
      </button>
    }
  </mat-menu>

</div>